/**
 * Modal reutilizável de captura de campos — substitui os prompt()/confirm
 * nativos do browser (item nº1 do dossiê de usabilidade). Valida obrigatórios,
 * fecha no Esc / clique fora, e segue o design system do módulo.
 *
 * Uso:
 *   <ModalCampos
 *     titulo="Lançar horas"
 *     campos={[{ nome:'horas', label:'Horas', tipo:'number', required:true, step:'0.5', min:'0' }]}
 *     confirmLabel="Lançar" confirmCor="var(--brand, #20a490)"
 *     onConfirm={(vals) => ...} onCancel={() => ...} />
 */
import React, { useEffect, useState } from 'react';

export default function ModalCampos({
  titulo, descricao, campos, valoresIniciais, confirmLabel = 'Confirmar', confirmCor = 'var(--brand, #20a490)',
  onConfirm, onCancel,
}) {
  const [vals, setVals] = useState(valoresIniciais || {});
  const [erro, setErro] = useState('');
  const set = (n, v) => setVals((x) => ({ ...x, [n]: v }));

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  function submit(e) {
    e.preventDefault();
    for (const c of campos) {
      if (c.required && !String(vals[c.nome] ?? '').trim()) {
        setErro(`Preencha: ${c.label}`); return;
      }
    }
    onConfirm(vals);
  }

  return (
    <div style={overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <form onSubmit={submit} style={box} onMouseDown={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 6px', color: '#2c3e50' }}>{titulo}</h3>
        {descricao && <p style={{ margin: '0 0 14px', color: '#7f8c8d', fontSize: '0.85rem' }}>{descricao}</p>}
        {campos.map((c, i) => (
          <div key={c.nome} style={{ marginBottom: 12 }}>
            <label style={lbl}>{c.label}{c.required && ' *'}</label>
            {c.tipo === 'textarea' ? (
              <textarea autoFocus={i === 0} value={vals[c.nome] || ''} placeholder={c.placeholder}
                        onChange={(e) => set(c.nome, e.target.value)} style={{ ...inp, minHeight: 72 }} />
            ) : c.tipo === 'select' ? (
              <select autoFocus={i === 0} value={vals[c.nome] || ''} style={inp}
                      onChange={(e) => set(c.nome, e.target.value)}>
                <option value="">{c.placeholder || '—'}</option>
                {(c.opcoes || []).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            ) : (
              <input type={c.tipo || 'text'} step={c.step} min={c.min} autoFocus={i === 0}
                     value={vals[c.nome] || ''} placeholder={c.placeholder}
                     onChange={(e) => set(c.nome, e.target.value)} style={inp} />
            )}
          </div>
        ))}
        {erro && <div style={{ color: '#e74c3c', fontSize: '0.82rem', marginBottom: 10 }}>{erro}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
          <button type="button" onClick={onCancel} style={{ ...btn, background: '#ecf0f1', color: '#555' }}>Cancelar</button>
          <button type="submit" style={{ ...btn, background: confirmCor, color: '#fff' }}>{confirmLabel}</button>
        </div>
      </form>
    </div>
  );
}

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(15,30,40,0.45)', zIndex: 1000,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
};
const box = {
  background: '#fff', borderRadius: 12, padding: 24, width: '100%', maxWidth: 440,
  boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
};
const inp = { width: '100%', padding: 9, borderRadius: 6, border: '1px solid #ccc', fontFamily: 'inherit', fontSize: '0.9rem', boxSizing: 'border-box' };
const lbl = { display: 'block', marginBottom: 4, fontSize: '0.85rem', color: '#555', fontWeight: 500 };
const btn = { padding: '9px 18px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '0.88rem', fontWeight: 500 };
